import { render } from "./PreSuffixInclude.vue?vue&type=template&id=5df22bd4"
import script from "./PreSuffixInclude.vue?vue&type=script&lang=js"
export * from "./PreSuffixInclude.vue?vue&type=script&lang=js"

import "./PreSuffixInclude.vue?vue&type=style&index=0&id=5df22bd4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__